import { Diamond } from "lucide-react";

const items = [
  "§7i Denkmal-AfA",
  "§7h Sanierungsgebiet",
  "§7g Investitionsabzugsbetrag",
  "EEG 2026",
  "100 % Sachwertschutz",
  "Krisenresistenz",
  "Steuerfrei nach Haltefrist",
  "Generationenvermögen",
];

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="overflow-hidden border-y border-forest/15 bg-sage py-5" aria-label="Steuerliche Stichworte">
    <div className="flex w-max animate-marquee whitespace-nowrap">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center" aria-hidden={copy === 1}>
          {items.map((item) => (
            <span key={`${copy}-${item}`} className="flex items-center">
              <span className="font-display text-lg italic text-forest px-6">{item}</span>
              <Diamond size={9} className="text-gold" fill="currentColor" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
